import React from 'react';

import NavbarHeader from './NavbarHeader/NavbarHeader';
import NavbarContainer from './NavbarContainer/NavbarContainer';
import Toolbar from './Toolbar/Toolbar';
import Search from './Search/Search';

const topMenu = () => (
    <nav className="navbar site-navbar navbar-default navbar-inverse navbar-fixed-top navbar-mega bg-brown-600" role="navigation">
        <NavbarHeader />
        <NavbarContainer>
            <Toolbar />
            <Search />
        </NavbarContainer>
    </nav>
);

export default topMenu;